import { useUser } from "contexts/UserContext";
import { routes } from "pages/routes";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useScreenSize from "utils/useScreenSize";
import { activateOnKeys } from "utils/a11y";

import laptop from "./laptop.svg";

import styles from "./SpeakingClubBanner.module.scss";
import speakingClubMascot from "./speakingClubMascot.svg";

function SpeakingClubBanner() {
  const { t } = useTranslation();
  const screenSize = useScreenSize();
  const navigate = useNavigate();
  const user = useUser();

  if (!user.canAccessSpeakingClub) {
    return null;
  }

  const onBannerClick = () => {
    navigate(routes.speakingClub.path());
  };

  const cta = <span className={styles.cta}>{t("Session.Banner.findSessions")}</span>;

  const description = (
    <div className={styles.description}>{t("Session.Banner.description")}</div>
  );

  return (
    <div
      className={styles.banner}
      role="button"
      tabIndex={0}
      onClick={onBannerClick}
      onKeyDown={activateOnKeys(onBannerClick)}
    >
      <div className={styles.content}>
        {screenSize.below("desktop") ? (
          <>
            <div className={styles.textContainer}>
              <div className={styles.title}>{t("Session.Banner.title")}</div>
              {description}
              {cta}
            </div>
            <div className={styles.mascots}>
              <img src={speakingClubMascot} alt={t("Session.Banner.mascotAlt")} />
              <img src={laptop} alt={t("Session.Banner.laptopAlt")} />
            </div>
          </>
        ) : (
          <>
            <img src={speakingClubMascot} alt={t("Session.Banner.mascotAlt")} />
            <div className={styles.textContainer}>
              <div className={styles.title}>
                {t("Session.Banner.title")} &nbsp;
                {cta}
              </div>
              {description}
            </div>
            <img src={laptop} alt={t("Session.Banner.laptopAlt")} />
          </>
        )}
      </div>
    </div>
  );
}

export default SpeakingClubBanner;
